import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ReactEcharts from 'echarts-for-react'

/**
 * @description Stacked bar chart with the daily distribution of conversations by traffic-light
 * status (green / yellow / red). Uses hex literals (ECharts renders to canvas and cannot
 * resolve CSS custom properties); green matches --secondary-300 (#69B75C) used across the dashboard,
 * so the report stays consistent with the chat list dot.
 * @param {{ data: { daily: Array<{date:string, green:number, yellow:number, red:number}> } }} props
 */
const SENTIMENT_COLOR = {
  green: '#69B75C',
  yellow: '#FACC15',
  red: '#EF4444'
}
function SentimentDailyGraph(props) {
  const { data, height = '100%' } = props
  const { t, i18n } = useTranslation('clients-dashboard', { keyPrefix: 'reportsScreen' })

  const option = useMemo(() => {
    const daily = data?.daily
    if (!daily || !daily.length) return

    const dates = daily.map((d) => d.date)
    const statuses = ['green', 'yellow', 'red']

    return {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, confine: true },
      legend: { icon: 'roundRect' },
      grid: { top: 44, right: 8, bottom: 24, left: 8, containLabel: true },
      xAxis: { type: 'category', data: dates },
      yAxis: { type: 'value' },
      series: statuses.map((status) => ({
        name: t(`sentimentStatus.${status}`),
        type: 'bar',
        stack: 'total',
        emphasis: { focus: 'series' },
        data: daily.map((d) => d[status] || 0),
        itemStyle: { color: SENTIMENT_COLOR[status] }
      }))
    }
  }, [data, i18n.language])

  return (
    <div className="dashboardView-card dashboard-graph-card">
      <p className="dashboardView-card-title">{t('sentimentDailyTitle')}</p>
      {option ? <ReactEcharts option={option} style={{ height }} /> : <p>N/D</p>}
    </div>
  )
}

export default SentimentDailyGraph
